interface state extends types.redux.rootReducer {}

export const filtersSelector = ({ numbers }: state) => numbers.filters;
